import { Box, Grid, Typography } from "@mui/material";
import KeyValueTextElement from "../../common/KeyValueTextElementComponent";

export const ChargePointStrategyDetailsComponent = ({ chargingStrategy }) => {
  const { chargingStrategyParts } = chargingStrategy;

  const formatStrategyTime = (timeString) => {
    const timeArray = timeString.split(":");
    if (timeArray.length >= 3) {
      return `${timeArray[0]}:${timeArray[1]}`;
    }
    return timeString;
  };

  const getStrategyDetailsElement = () => {
    switch (chargingStrategy.strategyType) {
      case 1:
        return getDynamicHourlyStrategyDetails();
      case 2:
        return getTaaozStrategyDetails();
    }
    return '';
  };

  const getDynamicHourlyStrategyDetails = () => {
    return (
      <div className="flexColumn gap10 textAlignCenter">
        {chargingStrategyParts?.map((strategyPart, partIdx) => (
          <div key={partIdx}>
            <KeyValueTextElement keyLabel="שעות צריכה" valueText={`${formatStrategyTime(strategyPart.endTime)} - ${formatStrategyTime(strategyPart.startTime)}`} />
            <KeyValueTextElement keyLabel="עלות שירות (₪)" valueText={strategyPart.serviceCost} />
            <KeyValueTextElement keyLabel='חשמל (₪/קוט"ש)' valueText={strategyPart.electricityCost} />
            <KeyValueTextElement keyLabel="עלות חנייה (₪)" valueText={strategyPart.parkingCost} showBorder={true} />
          </div>
        ))}
        <label>חיוב עבור שירות יתבצע פעם אחת בלבד לפי תעריף השירות ברגע תחילת הטעינה </label>
        <label>{chargingStrategy.includeVat ? 'המחיר כולל מע"מ' : 'המחיר לא כולל מע"מ'}</label>
      </div>
    );
  };

  const getTaaozStrategyDetails = () => {
    return <div className="flexColumn gap10 textAlignCenter">
      <label>תעריף טעינה זה נקבע על ידי תעריף תעו"ז של חברת החשמל בתוספת {chargingStrategy.extraCostsType === 1 ? `${chargingStrategy.extraCostsAmount} אחוז`:`${chargingStrategy.extraCostsAmount} ש"ח`}</label>
      <label>ניתן לצפות בתעריף תעו"ז הנוכחי באתר הרשמי של חברת החשמל</label>
    </div>;
  };

  return getStrategyDetailsElement();
};

export default ChargePointStrategyDetailsComponent;
